import prepareOptions from '../../prepareOptions';
import {
  DISTANCE_ASC,
  DISTANCE_DESC,
  GEOLOCATION_DISTANCE_ASC,
  MANUFACTURER_ASC,
  MANUFACTURER_DESC,
  MONTHLY_PRICE_ASC,
  MONTHLY_PRICE_DESC,
  PRICE_ASC,
  PRICE_DESC,
  PUBLISHED_AT_DESC,
  STANDARD_PRICE_ASC,
} from './values';

export default prepareOptions([
  {
    label: __('search.filters.sort.latestFirst'),
    value: PUBLISHED_AT_DESC,
  },
  {
    label: __('search.filters.sort.standardAsc'),
    value: STANDARD_PRICE_ASC,
  },
  {
    label: __('search.filters.sort.price.asc'),
    value: PRICE_ASC,
  },
  {
    label: __('search.filters.sort.price.desc'),
    value: PRICE_DESC,
  },
  {
    label: __('search.filters.sort.distance.asc'),
    value: DISTANCE_ASC,
  },
  {
    label: __('search.filters.sort.distance.desc'),
    value: DISTANCE_DESC,
  },
  {
    label: __('search.filters.sort.manufacturer.asc'),
    value: MANUFACTURER_ASC,
  },
  {
    label: __('search.filters.sort.manufacturer.desc'),
    value: MANUFACTURER_DESC,
  },
  {
    label: __('search.filters.sort.monthlyPrice.asc'),
    value: MONTHLY_PRICE_ASC,
  },
  {
    label: __('search.filters.sort.monthlyPrice.desc'),
    value: MONTHLY_PRICE_DESC,
  },
  {
    label: __('search.filters.sort.geoLocationDistance.asc'),
    value: GEOLOCATION_DISTANCE_ASC,
  },
]);
